import * as t from "./actionType";

const initialState = {
  // AP
  apList: [],
  apListLoading: false,
  apData: [],
  apDataLoading: false,
  apCreate: [],
  apCreateLoading: false,
  apUpdate: [],
  apUpdateLoading: false,
  apDelete: [],
  apDeleteLoading: false,
  // PROFILE
  profileList: [],
  profileListLoading: false,
  profileData: [],
  profileDataLoading: false,
  profileCreate: [],
  profileCreateLoading: false,
  profileUpdate: [],
  profileUpdateLoading: false,
  profileDelete: [],
  profileDeleteLoading: false,
  // SITE
  siteList: [],
  siteListLoading: false,
  siteData: [],
  siteDataLoading: false,
  siteCreate: [],
  siteCreateLoading: false,
  siteUpdate: [],
  siteUpdateLoading: false,
  siteDelete: [],
  siteDeleteLoading: false,
  siteUnifiTest: [],
  siteUnifiTestLoading: false,
  siteUnifiSync: [],
  siteUnifiSyncLoading: false,
  siteComoTest: [],
  siteComoTestLoading: false,
  // REG
  regList: [],
  regListLoading: false,
  regData: [],
  regDataLoading: false,
  regSearch: [],
  regSearchLoading: false,
  // ERRLOG
  errLogList: [],
  errLogListLoading: false,
  errLogData: [],
  errLogDataLoading: false,
  errLogSearch: [],
  errLogSearchLoading: false,
  // LINK
  linkList: [],
  linkListLoading: false,
  linkCreate: [],
  linkCreateLoading: false,
  linkDelete: [],
  linkDeleteLoading: false,
};

const Wifi = (state = initialState, action) => {
  switch (action.type) {
    // ---------- AP ----------
    case t.WIFI_AP_LIST:
      return { ...state, apListLoading: true };
    case t.WIFI_AP_LIST_SUCCESS:
      return { ...state, apList: action.data, apListLoading: false };
    case t.WIFI_AP_LIST_FAIL:
      return { ...state, apListLoading: false };

    case t.WIFI_AP_DATA:
      return { ...state, apDataLoading: true };
    case t.WIFI_AP_DATA_SUCCESS:
      return { ...state, apData: action.data, apDataLoading: false };
    case t.WIFI_AP_DATA_FAIL:
      return { ...state, apDataLoading: false };

    case t.WIFI_AP_CREATE:
      return { ...state, apCreateLoading: true };
    case t.WIFI_AP_CREATE_SUCCESS:
      return { ...state, apCreate: action.data, apCreateLoading: false };
    case t.WIFI_AP_CREATE_FAIL:
      return { ...state, apCreateLoading: false };
    case t.WIFI_AP_CREATE_RESET:
      return { ...state, apCreate: [] };

    case t.WIFI_AP_UPDATE:
      return { ...state, apUpdateLoading: true };
    case t.WIFI_AP_UPDATE_SUCCESS:
      return { ...state, apUpdate: action.data, apUpdateLoading: false };
    case t.WIFI_AP_UPDATE_FAIL:
      return { ...state, apUpdateLoading: false };
    case t.WIFI_AP_UPDATE_RESET:
      return { ...state, apUpdate: [] };

    case t.WIFI_AP_DELETE:
      return { ...state, apDeleteLoading: true };
    case t.WIFI_AP_DELETE_SUCCESS:
      return { ...state, apDelete: action.data, apDeleteLoading: false };
    case t.WIFI_AP_DELETE_FAIL:
      return { ...state, apDeleteLoading: false };
    case t.WIFI_AP_DELETE_RESET:
      return { ...state, apDelete: [] };

    // ---------- PROFILE ----------
    case t.WIFI_PROFILE_LIST:
      return { ...state, profileListLoading: true };
    case t.WIFI_PROFILE_LIST_SUCCESS:
      return { ...state, profileList: action.data, profileListLoading: false };
    case t.WIFI_PROFILE_LIST_FAIL:
      return { ...state, profileListLoading: false };

    case t.WIFI_PROFILE_DATA:
      return { ...state, profileDataLoading: true };
    case t.WIFI_PROFILE_DATA_SUCCESS:
      return { ...state, profileData: action.data, profileDataLoading: false };
    case t.WIFI_PROFILE_DATA_FAIL:
      return { ...state, profileDataLoading: false };

    case t.WIFI_PROFILE_CREATE:
      return { ...state, profileCreateLoading: true };
    case t.WIFI_PROFILE_CREATE_SUCCESS:
      return { ...state, profileCreate: action.data, profileCreateLoading: false };
    case t.WIFI_PROFILE_CREATE_FAIL:
      return { ...state, profileCreateLoading: false };
    case t.WIFI_PROFILE_CREATE_RESET:
      return { ...state, profileCreate: [] };

    case t.WIFI_PROFILE_UPDATE:
      return { ...state, profileUpdateLoading: true };
    case t.WIFI_PROFILE_UPDATE_SUCCESS:
      return { ...state, profileUpdate: action.data, profileUpdateLoading: false };
    case t.WIFI_PROFILE_UPDATE_FAIL:
      return { ...state, profileUpdateLoading: false };
    case t.WIFI_PROFILE_UPDATE_RESET:
      return { ...state, profileUpdate: [] };

    case t.WIFI_PROFILE_DELETE:
      return { ...state, profileDeleteLoading: true };
    case t.WIFI_PROFILE_DELETE_SUCCESS:
      return { ...state, profileDelete: action.data, profileDeleteLoading: false };
    case t.WIFI_PROFILE_DELETE_FAIL:
      return { ...state, profileDeleteLoading: false };
    case t.WIFI_PROFILE_DELETE_RESET:
      return { ...state, profileDelete: [] };

    // ---------- SITE ----------
    case t.WIFI_SITE_LIST:
      return { ...state, siteListLoading: true };
    case t.WIFI_SITE_LIST_SUCCESS:
      return { ...state, siteList: action.data, siteListLoading: false };
    case t.WIFI_SITE_LIST_FAIL:
      return { ...state, siteListLoading: false };

    case t.WIFI_SITE_DATA:
      return { ...state, siteDataLoading: true };
    case t.WIFI_SITE_DATA_SUCCESS:
      return { ...state, siteData: action.data, siteDataLoading: false };
    case t.WIFI_SITE_DATA_FAIL:
      return { ...state, siteDataLoading: false };

    case t.WIFI_SITE_CREATE:
      return { ...state, siteCreateLoading: true };
    case t.WIFI_SITE_CREATE_SUCCESS:
      return { ...state, siteCreate: action.data, siteCreateLoading: false };
    case t.WIFI_SITE_CREATE_FAIL:
      return { ...state, siteCreateLoading: false };
    case t.WIFI_SITE_CREATE_RESET:
      return { ...state, siteCreate: [] };

    case t.WIFI_SITE_UPDATE:
      return { ...state, siteUpdateLoading: true };
    case t.WIFI_SITE_UPDATE_SUCCESS:
      return { ...state, siteUpdate: action.data, siteUpdateLoading: false };
    case t.WIFI_SITE_UPDATE_FAIL:
      return { ...state, siteUpdateLoading: false };
    case t.WIFI_SITE_UPDATE_RESET:
      return { ...state, siteUpdate: [] };

    case t.WIFI_SITE_DELETE:
      return { ...state, siteDeleteLoading: true };
    case t.WIFI_SITE_DELETE_SUCCESS:
      return { ...state, siteDelete: action.data, siteDeleteLoading: false };
    case t.WIFI_SITE_DELETE_FAIL:
      return { ...state, siteDeleteLoading: false };
    case t.WIFI_SITE_DELETE_RESET:
      return { ...state, siteDelete: [] };

    case t.WIFI_SITE_UNIFI_TEST:
      return { ...state, siteUnifiTestLoading: true };
    case t.WIFI_SITE_UNIFI_TEST_SUCCESS:
      return { ...state, siteUnifiTest: action.data, siteUnifiTestLoading: false };
    case t.WIFI_SITE_UNIFI_TEST_FAIL:
      return { ...state, siteUnifiTestLoading: false };
    case t.WIFI_SITE_UNIFI_TEST_RESET:
      return { ...state, siteUnifiTest: [] };

    case t.WIFI_SITE_UNIFI_SYNC:
      return { ...state, siteUnifiSyncLoading: true };
    case t.WIFI_SITE_UNIFI_SYNC_SUCCESS:
      return { ...state, siteUnifiSync: action.data, siteUnifiSyncLoading: false };
    case t.WIFI_SITE_UNIFI_SYNC_FAIL:
      return { ...state, siteUnifiSyncLoading: false };
    case t.WIFI_SITE_UNIFI_SYNC_RESET:
      return { ...state, siteUnifiSync: [] };

    case t.WIFI_SITE_COMO_TEST:
      return { ...state, siteComoTestLoading: true };
    case t.WIFI_SITE_COMO_TEST_SUCCESS:
      return { ...state, siteComoTest: action.data, siteComoTestLoading: false };
    case t.WIFI_SITE_COMO_TEST_FAIL:
      return { ...state, siteComoTestLoading: false };
    case t.WIFI_SITE_COMO_TEST_RESET:
      return { ...state, siteComoTest: [] };

    // ---------- REG ----------
    case t.WIFI_REG_LIST:
      return { ...state, regListLoading: true };
    case t.WIFI_REG_LIST_SUCCESS:
      return { ...state, regList: action.data, regListLoading: false };
    case t.WIFI_REG_LIST_FAIL:
      return { ...state, regListLoading: false };

    case t.WIFI_REG_DATA:
      return { ...state, regDataLoading: true };
    case t.WIFI_REG_DATA_SUCCESS:
      return { ...state, regData: action.data, regDataLoading: false };
    case t.WIFI_REG_DATA_FAIL:
      return { ...state, regDataLoading: false };

    case t.WIFI_REG_SEARCH:
      return { ...state, regSearchLoading: true };
    case t.WIFI_REG_SEARCH_SUCCESS:
      return { ...state, regSearch: action.data, regSearchLoading: false };
    case t.WIFI_REG_SEARCH_FAIL:
      return { ...state, regSearchLoading: false };

    // ---------- ERRLOG ----------
    case t.WIFI_ERRLOG_LIST:
      return { ...state, errLogListLoading: true };
    case t.WIFI_ERRLOG_LIST_SUCCESS:
      return { ...state, errLogList: action.data, errLogListLoading: false };
    case t.WIFI_ERRLOG_LIST_FAIL:
      return { ...state, errLogListLoading: false };

    case t.WIFI_ERRLOG_DATA:
      return { ...state, errLogDataLoading: true };
    case t.WIFI_ERRLOG_DATA_SUCCESS:
      return { ...state, errLogData: action.data, errLogDataLoading: false };
    case t.WIFI_ERRLOG_DATA_FAIL:
      return { ...state, errLogDataLoading: false };

    case t.WIFI_ERRLOG_SEARCH:
      return { ...state, errLogSearchLoading: true };
    case t.WIFI_ERRLOG_SEARCH_SUCCESS:
      return { ...state, errLogSearch: action.data, errLogSearchLoading: false };
    case t.WIFI_ERRLOG_SEARCH_FAIL:
      return { ...state, errLogSearchLoading: false };

    // ---------- LINK ----------
    case t.WIFI_LINK_LIST:
      return { ...state, linkListLoading: true };
    case t.WIFI_LINK_LIST_SUCCESS:
      return { ...state, linkList: action.data, linkListLoading: false };
    case t.WIFI_LINK_LIST_FAIL:
      return { ...state, linkListLoading: false };

    case t.WIFI_LINK_CREATE:
      return { ...state, linkCreateLoading: true };
    case t.WIFI_LINK_CREATE_SUCCESS:
      return { ...state, linkCreate: action.data, linkCreateLoading: false };
    case t.WIFI_LINK_CREATE_FAIL:
      return { ...state, linkCreateLoading: false };
    case t.WIFI_LINK_CREATE_RESET:
      return { ...state, linkCreate: [] };

    case t.WIFI_LINK_DELETE:
      return { ...state, linkDeleteLoading: true };
    case t.WIFI_LINK_DELETE_SUCCESS:
      return { ...state, linkDelete: action.data, linkDeleteLoading: false };
    case t.WIFI_LINK_DELETE_FAIL:
      return { ...state, linkDeleteLoading: false };
    case t.WIFI_LINK_DELETE_RESET:
      return { ...state, linkDelete: [] };

    default:
      return state;
  }
};

export default Wifi;
